const listItemStyle = {
  color: "inherit",
  "&.active": {
    backgroundColor: "#f4f4f9",
    color: "red",
    "& .myIconClass, & .MuiTypography-root": {
      color: "#002855 !important",
      fontWeight: "bold",
    },
  },
};
const buttonStyle = {
  "&:hover": {
    color: "white",
    "& .myIconClass, & .MuiTypography-root": {
      color: "#04BCFA",
    },
  },
};

export { listItemStyle, buttonStyle };
